import { ShopsActionType, ShopAction } from '../actions/shopsActions';
import { Shop, idle, Loadable, LoadableStatus, assertFetched } from '@card/types';

type ShopsStatuses = {
  OK: 'OK';
  FETCHING: 'FETCHING';
  FETCH_ERROR: 'FETCH_ERROR';
};

export interface ShopsState {
  shopsList: Shop[];
  shops: Loadable<Shop[]>;
  status: keyof ShopsStatuses;
}

const initialState: ShopsState = {
  shopsList: [],
  shops: idle(),
  status: 'OK'
};

function shopsReducers(state = initialState, action: ShopAction): ShopsState {
  switch (action.type) {
    case ShopsActionType.Fetch:
      return {
        ...state,
        shops: { ...state.shops, status: LoadableStatus.Fetching },
        status: 'FETCHING'
      };
    case ShopsActionType.FetchSuccess:
      return {
        ...state,
        shopsList: action.payload,
        status: 'OK',
        shops: { ...state.shops, data: action.payload, status: LoadableStatus.Fetched }
      };
    case ShopsActionType.FetchError:
      return {
        ...state,
        status: 'FETCH_ERROR',
        shops: { ...state.shops, status: LoadableStatus.Error, error: action.payload }
      };
    case ShopsActionType.ModifyShopName: {
      if (!assertFetched(state.shops)) return state;

      const { id, name } = action.payload;
      const shops = state.shops.data.map((shop) => {
        if (shop.id === id) {
          return { ...shop, name, modified: true } as Shop;
        }
        return shop;
      });
      return {
        ...state,
        shopsList: shops,
        shops: { ...state.shops, data: shops }
      };
    }
    case ShopsActionType.DeleteShop: {
      if (!assertFetched(state.shops)) return state;
      const position = action.payload;
      const newShops = state.shops.data.filter((_shop, index) => index !== position);
      // borrar del state
      return {
        ...state,
        shopsList: newShops,
        shops: { ...state.shops, data: newShops }
      };
    }
    case ShopsActionType.DestroyShop: {
      if (!assertFetched(state.shops)) return state;
      const position = action.payload.position;
      const newShops = state.shops.data.map((shop, index) => {
        if (index === position) {
          return { ...shop, status: 'FETCHING' } as Shop;
        }
        return shop;
      });
      return {
        ...state,
        shopsList: newShops,
        shops: { ...state.shops, data: newShops }
      };
    }
    case ShopsActionType.ActionSetShopName: {
      if (!assertFetched(state.shops)) return state;
      const { position, name } = action.payload;
      const newShops = state.shops.data.map((shop, index) => {
        if (index === position) {
          return { ...shop, name, modified: true } as Shop;
        }
        return shop;
      });
      return {
        ...state,
        shopsList: newShops,
        shops: { ...state.shops, data: newShops }
      };
    }
    case ShopsActionType.SaveShops: {
      return {
        ...state,
        status: 'FETCHING'
      };
    }
    case ShopsActionType.AsyncSetShopNameStatus: {
      if (!assertFetched(state.shops)) return state;
      const id = action.payload;
      const shops = state.shops.data.map((shop) => {
        if (shop.id === id) {
          return { ...shop, status: 'LOADING' } as Shop;
        }
        return shop;
      });
      return {
        ...state,
        shopsList: shops,
        shops: { ...state.shops, data: shops }
      };
    }
    case ShopsActionType.UpdateShopError: {
      if (!assertFetched(state.shops)) return state;
      const id = action.payload.id;
      const shops = state.shops.data.map((shop) => {
        if (shop.id === id) {
          return { ...shop, status: 'FETCH_ERROR' } as Shop;
        }
        return shop;
      });
      return {
        ...state,
        shopsList: shops,
        shops: { ...state.shops, data: shops }
      };
    }
    default:
      return state;
  }
}

export default shopsReducers;
